export default __webpack_public_path__ + "static/media/20.14044ac2.jpg";